import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import SearchBar from './SearchBar';

export default function FullScreenSearch({ setShow }) {
  return (
    // Fondo opaco: translúcido, la página de atrás se mezclaba con las sugerencias.
    <div className="fixed inset-0 z-50 overflow-hidden bg-white">
      <div className="flex flex-col h-full max-w-lg mx-auto px-5">
        {/* Header */}
        <div className="flex items-center justify-between h-14 flex-shrink-0">
          <h3 className="text-base font-bold text-[#111] tracking-[-0.01em]">Buscar</h3>
          <button
            onClick={() => setShow(false)}
            aria-label="Cerrar búsqueda"
            className="w-9 h-9 flex items-center justify-center rounded-xl glass-button -mr-1"
          >
            <XMarkIcon className="h-5 w-5 text-gray-500" />
          </button>
        </div>

        {/* Divider */}
        <div className="h-px -mx-5" style={{ background: 'linear-gradient(90deg, transparent, rgba(0,0,0,0.06), transparent)' }} />

        {/* Search content */}
        <div className="flex-1 overflow-y-auto pb-safe">
          <SearchBar isNavbar={false} isFullScreen />
        </div>
      </div>
    </div>
  );
}
